import React from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { Model } from "../../../types";
import { ModelFormProps, ModelFormData } from "../types/models-types";
import { modelSchema } from "../../../schemas/forms";
import { ControlledTextField } from "../../../components/form";
import { ControlledSelect } from "../../../components/form";

export const ModelForm: React.FC<ModelFormProps> = ({
  onSubmit,
  initialValues,
  isLoading = false,
  brands,
  selectedBrandId,
}) => {
  const form = useForm<ModelFormData>({
    resolver: zodResolver(modelSchema),
    defaultValues: {
      name: initialValues?.name || "",
      brandId: initialValues?.brandId || selectedBrandId || "",
    },
  });

  const handleFormSubmit = async (data: ModelFormData): Promise<void> => {
    const modelData: Partial<Model> = {
      name: data.name,
      brandId: data.brandId,
    };
    await onSubmit(modelData);
  };

  return (
    <form
      onSubmit={form.handleSubmit(handleFormSubmit)}
      className="form-space-y-2"
    >
      <ControlledTextField
        control={form.control}
        name="name"
        label="Название модели"
        placeholder="Введите название модели"
        required
        disabled={isLoading}
      />

      {!selectedBrandId && (
        <ControlledSelect
          control={form.control}
          name="brandId"
          label="Бренд"
          placeholder="Выберите бренд"
          required
          disabled={isLoading}
          options={brands.map((brand) => ({
            value: brand.id,
            label: brand.name,
          }))}
        />
      )}

      <div className="form-wrapper__actions">
        <button
          type="submit"
          className="form-button form-button--primary form-button--full"
          disabled={isLoading}
        >
          {isLoading
            ? "Загрузка..."
            : initialValues
            ? "Сохранить изменения"
            : "Добавить модель"}
        </button>
      </div>
    </form>
  );
};
